/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".search-container[_ngcontent-%COMP%]{position:relative}.search-btn[_ngcontent-%COMP%]{width:32px;height:32px;fill:#9ca4a6;position:absolute;top:8px;right:8px}.search-input[_ngcontent-%COMP%]{border:1px solid #babebf;border-radius:4px;background-color:#fff;background-size:cover;box-shadow:0 2px 4px rgba(0,0,0,.1);padding-right:64px}"];
export { styles as styles };
